import type { FaireProductEntity } from "../../entity_types/product";

export const p_7gkbze6mjm: FaireProductEntity = {
  token: "p_7gkbze6mjm",
  type: "product",
  name: "Soapstone Cactus Crystal Carving from Peru",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/73554ba6a88c17584671ad2e718426feec1ec10c87526134c4da28a962e9a1e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/deebacfd76d7c903559993834807ef862260c12dfa07ce1f6883aca84fe72b2d.jpeg",
    "https://cdn.faire.com/fastly/1774719a2ca1c647301f18c0b641d0a2b5d26c76f280b3b554713174bb54e6e6.jpeg",
    "https://cdn.faire.com/fastly/ba1377155b8563312df57f6ad0d507e9165d12fc5a1b7028b21981c05e213ffc.jpeg",
    "https://cdn.faire.com/fastly/b311cbe172b84a189e45b232e305e3904775cc0558c55c62fb1f6d6388c28c07.jpeg",
    "https://cdn.faire.com/fastly/85c590c41fa817f3afb6102a9b52d3abb76f193ff2f4583d1eae0d7b49ccd38a.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "Soapstone cactus crystal carving from peru - you choose color\n\nThis listing is for one (1) soapstone cactus crystal carving from peru - you choose color. Lws-s3-b45-05\n\nAdorable cactus figurines carved out of soapstone from peru make fantastic collectibles and gifts! Each have been meticulously carved into miniature cactus with three branches. Available in red, tan, and gray soapstone.\n\nWhy you'll love a soapstone cactus carving:\n\n * hand carved: each cactus has been hand carved by expert crystal artisans from peru. \n * lovely colors: available in red, tan and gray, these cacti exhibit lovely coloration from the natural properties of soapstone. \n * adorable animal shape: makes a perfect collectible to anyone who loves cacti!",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:50.896Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
